var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$i18n.locale === "pe"
      ? _c("div", [
          _vm.$store.state.currentUser.user.rol !== "CLIENT"
            ? _c("div", { attrs: { id: "notPermissions" } }, [
                _c("p", [
                  _vm._v(
                    "Usted no tiene permisos para ver este menú. Consulte al equipo de desarrollo para más información."
                  ),
                ]),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.$i18n.locale === "br"
      ? _c("div", [
          _vm.$store.state.currentUser.user.rol !== "CLIENT"
            ? _c("div", { attrs: { id: "notPermissions" } }, [
                _c("p", [
                  _vm._v(
                    "Você não tem permissão para visualizar este menu. Consulte a equipe de desenvolvimento para mais informações."
                  ),
                ]),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    (_vm.$i18n.locale === "cl") &
    (_vm.$store.state.currentUser.user.rol !== "CLIENT")
      ? _c("div", [_vm._m(0)])
      : _vm._e(),
    _vm.showResume
      ? _c(
          "section",
          { staticClass: "card-item mb-6" },
          [
            _c(
              "div",
              { staticClass: "is-flex is-justify-content-space-between" },
              [
                _vm._m(1),
                _c(
                  "b-button",
                  {
                    staticClass: "mt-2",
                    attrs: { type: "is-text", size: "is-small" },
                    on: {
                      click: () => {
                        _vm.$router.push({ name: "credit-resume" })
                      },
                    },
                  },
                  [_vm._v("Ver detalle")]
                ),
              ],
              1
            ),
            _vm._l(_vm.clientDataResume, function (operation, i) {
              return _c(
                "div",
                {
                  key: `operation${i}`,
                  class: [
                    "message-item",
                    { "last-message": i === _vm.clientDataResume.length - 1 },
                  ],
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "message-item-inner credit-resume-list is-flex is-justify-content-space-between my-2 p-2",
                    },
                    [
                      _c("div", [
                        _c(
                          "p",
                          {
                            staticClass:
                              "has-text-weight-medium is-size-6 my-1",
                            attrs: { id: "creditName" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(operation.creditType?.toLowerCase())
                              )
                            ),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "my-1" },
                        [
                          operation.judicial === true
                            ? _c(
                                "b-tag",
                                {
                                  staticClass: "is-size-7",
                                  attrs: {
                                    rounded: "",
                                    type: "is-light is-danger",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("isJudicial")) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          operation.upToDate === true
                            ? _c(
                                "b-tag",
                                {
                                  staticClass: "is-size-7",
                                  attrs: {
                                    rounded: "",
                                    type: "is-light is-primary",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("currentFeeFalse")) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          operation.forDue === true
                            ? _c(
                                "b-tag",
                                {
                                  staticClass: "is-size-7",
                                  attrs: {
                                    rounded: "",
                                    type: "is-light is-primary",
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("isForDue")) + " ")]
                              )
                            : _vm._e(),
                          operation.overdue === true
                            ? _c(
                                "b-tag",
                                {
                                  staticClass: "is-size-7",
                                  attrs: {
                                    rounded: "",
                                    type: "is-light is-danger",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("currentFeeTrue")) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          operation.defaulter === true
                            ? _c(
                                "b-tag",
                                {
                                  staticClass: "is-size-7",
                                  attrs: {
                                    rounded: "",
                                    type: "is-light is-danger",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("isDefaulter")) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              )
            }),
            _c(
              "div",
              { staticClass: "is-flex is-justify-content-flex-end" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "mt-2",
                    attrs: { rounded: "", type: "is-danger", size: "is-small" },
                    on: {
                      click: () => {
                        _vm.$router.push({ name: "pay-here" })
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("pay-here")))]
                ),
              ],
              1
            ),
          ],
          2
        )
      : _vm._e(),
    _vm.$store.state.currentUser.user.rol === "CLIENT" && !_vm.showResume
      ? _c(
          "section",
          { staticClass: "card-item mb-6", attrs: { id: "resume" } },
          [
            _c("div", { attrs: { id: "operations" } }, [
              _c(
                "div",
                {
                  staticClass:
                    "is-flex is-justify-content-space-between is-align-items-center px-4",
                },
                [
                  _vm.welcomeDate.type === "MORTGAGE"
                    ? _c(
                        "h2",
                        {
                          staticClass:
                            "has-text-grey has-text-weight-medium is-size-6",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.welcomeDate.years === false &&
                                  _vm.welcomeDate.months === false
                                  ? _vm.$t("ownedSinceDays")
                                  : _vm.$t("ownedSince")
                              ) +
                              " " +
                              _vm._s(
                                _vm.welcomeDate.years &&
                                  _vm.welcomeDate.years == 1
                                  ? _vm.welcomeDate.years + _vm.$t("singleYear")
                                  : _vm.welcomeDate.years === false
                                  ? ""
                                  : _vm.welcomeDate.years + _vm.$t("pluralYear")
                              ) +
                              _vm._s(
                                _vm.welcomeDate.years !== false &&
                                  _vm.welcomeDate.months !== false
                                  ? _vm.$t("and")
                                  : ""
                              ) +
                              " " +
                              _vm._s(
                                _vm.welcomeDate.months &&
                                  _vm.welcomeDate.months == 1
                                  ? _vm.welcomeDate.months +
                                      _vm.$t("singleMonth")
                                  : _vm.welcomeDate.months === false
                                  ? ""
                                  : _vm.welcomeDate.months +
                                    _vm.$t("pluralMonth")
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm.welcomeDate.type === "SME"
                    ? _c(
                        "h2",
                        {
                          staticClass:
                            "has-text-grey has-text-weight-medium is-size-6",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.welcomeDate.years === false &&
                                  _vm.welcomeDate.months === false
                                  ? _vm.$t("ownedSinceDaysSME")
                                  : _vm.$t("ownedSinceSME")
                              ) +
                              " " +
                              _vm._s(
                                _vm.welcomeDate.years &&
                                  _vm.welcomeDate.years == 1
                                  ? _vm.welcomeDate.years + _vm.$t("singleYear")
                                  : _vm.welcomeDate.years === false
                                  ? ""
                                  : _vm.welcomeDate.years + _vm.$t("pluralYear")
                              ) +
                              _vm._s(
                                _vm.welcomeDate.years !== false &&
                                  _vm.welcomeDate.months !== false
                                  ? _vm.$t("and")
                                  : ""
                              ) +
                              " " +
                              _vm._s(
                                _vm.welcomeDate.months &&
                                  _vm.welcomeDate.months == 1
                                  ? _vm.welcomeDate.months +
                                      _vm.$t("singleMonth")
                                  : _vm.welcomeDate.months === false
                                  ? ""
                                  : _vm.welcomeDate.months +
                                    _vm.$t("pluralMonth")
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm.welcomeDate.type === "PARKING"
                    ? _c(
                        "h2",
                        {
                          staticClass:
                            "has-text-grey has-text-weight-medium is-size-6",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.welcomeDate.years === false &&
                                  _vm.welcomeDate.months === false
                                  ? _vm.$t("ownedSinceDaysParking")
                                  : _vm.$t("ownedSinceParking")
                              ) +
                              " " +
                              _vm._s(
                                _vm.welcomeDate.years &&
                                  _vm.welcomeDate.years == 1
                                  ? _vm.welcomeDate.years + _vm.$t("singleYear")
                                  : _vm.welcomeDate.years === false
                                  ? ""
                                  : _vm.welcomeDate.years + _vm.$t("pluralYear")
                              ) +
                              _vm._s(
                                _vm.welcomeDate.years !== false &&
                                  _vm.welcomeDate.months !== false
                                  ? _vm.$t("and")
                                  : ""
                              ) +
                              " " +
                              _vm._s(
                                _vm.welcomeDate.months &&
                                  _vm.welcomeDate.months == 1
                                  ? _vm.welcomeDate.months +
                                      _vm.$t("singleMonth")
                                  : _vm.welcomeDate.months === false
                                  ? ""
                                  : _vm.welcomeDate.months +
                                    _vm.$t("pluralMonth")
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        rounded: "",
                        type: "is-danger",
                        size: "is-small",
                      },
                      on: {
                        click: () => {
                          _vm.$router.push({ name: "pay-here" })
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("pay-here")) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "box p-2 my-1" },
                _vm._l(_vm.clientDataResume, function (operation, i) {
                  return _c(
                    "div",
                    {
                      key: `operation${i}`,
                      class: [
                        "message-item",
                        {
                          "last-message": i === _vm.clientDataResume.length - 1,
                        },
                      ],
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "message-item-inner p-3 my-1" },
                        [
                          _c("header", [
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "is-flex is-justify-content-space-between is-align-items-center",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "is-flex is-align-items-center",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "is-flex is-flex-direction-column",
                                        },
                                        [
                                          _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "is-flex is-align-items-center",
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "has-text-weight-medium is-size-6",
                                                    attrs: { id: "creditName" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("creditName") +
                                                          operation.companyOperationId
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "is-flex is-align-items-center is-flex-wrap-wrap mt-2",
                                              },
                                              [
                                                _c(
                                                  "b-tag",
                                                  {
                                                    staticClass: "my-1",
                                                    attrs: {
                                                      id: "creditType",
                                                      rounded: "",
                                                      type: "is-light mr-2",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          operation.creditType?.toLowerCase()
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "b-tag",
                                                  {
                                                    staticClass: "my-1",
                                                    attrs: {
                                                      id: "insolute",
                                                      rounded: "",
                                                      type: "is-light mr-2",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t("insolute")
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          operation.creditType ===
                                                            "MORTGAGE" ||
                                                            operation.creditType ===
                                                              "PARKING"
                                                            ? _vm.$t(
                                                                "mortgageMonetaryValue"
                                                              )
                                                            : _vm.$t(
                                                                "complementaryMonetaryValue"
                                                              )
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.formatter.format(
                                                            operation.balanceAmmount.toFixed(
                                                              2
                                                            )
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "b-tag",
                                                  {
                                                    staticClass: "my-1",
                                                    attrs: {
                                                      id: "fee",
                                                      rounded: "",
                                                      type: "is-light mr-2",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        operation.currentPaidFee +
                                                          _vm.$t("of") +
                                                          operation.termAsMonths +
                                                          _vm.$t("dues")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "is-flex is-align-items-center is-justify-content-space-between",
                                              },
                                              [
                                                operation.judicial === true
                                                  ? _c(
                                                      "b-tag",
                                                      {
                                                        staticClass:
                                                          "is-size-7 mt-3",
                                                        attrs: {
                                                          rounded: "",
                                                          type: "is-light is-danger",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "isJudicial"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                operation.upToDate === true
                                                  ? _c(
                                                      "b-tag",
                                                      {
                                                        staticClass:
                                                          "is-size-7 mt-3",
                                                        attrs: {
                                                          rounded: "",
                                                          type: "is-light is-primary",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "currentFeeFalse"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                operation.forDue === true
                                                  ? _c(
                                                      "b-tag",
                                                      {
                                                        staticClass:
                                                          "is-size-7 mt-3",
                                                        attrs: {
                                                          rounded: "",
                                                          type: "is-light is-primary",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t("isForDue")
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                operation.overdue === true
                                                  ? _c(
                                                      "b-tag",
                                                      {
                                                        staticClass:
                                                          "is-size-7 mt-3",
                                                        attrs: {
                                                          rounded: "",
                                                          type: "is-light is-danger",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "currentFeeTrue"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                operation.defaulter === true
                                                  ? _c(
                                                      "b-tag",
                                                      {
                                                        staticClass:
                                                          "is-size-7 mt-3",
                                                        attrs: {
                                                          rounded: "",
                                                          type: "is-light is-danger",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "isDefaulter"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    [
                                      _vm.hasInsuranceAvailable(operation)
                                        ? _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "toggleButton is-rounded ml-2",
                                              attrs: {
                                                id: "insurancesClick",
                                                size: "is-small",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleCollapse(i)
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas",
                                                class: {
                                                  "fa-angle-down":
                                                    !_vm.collapseStates[i],
                                                  "fa-angle-up":
                                                    _vm.collapseStates[i],
                                                },
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        [
                          _vm.hasInsuranceAvailable(operation)
                            ? _c(
                                "b-collapse",
                                {
                                  staticClass: "message-body",
                                  attrs: {
                                    animation: "slide",
                                    open: _vm.collapseStates[i],
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "content-insurance mt-1 mb-3 p-4",
                                    },
                                    [
                                      operation.debtorLifeInsuranceType
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "is-flex is-flex-wrap-wrap",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "is-size-7 has-text-grey has-text-weight-semibold",
                                                  attrs: {
                                                    id: "insurancesType",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        operation.debtorLifeInsuranceType
                                                          ? _vm.getlifeInsuranceLabel(
                                                              operation.debtorLifeInsuranceType
                                                            )
                                                          : ""
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "is-size-7 has-text-grey ml-1",
                                                  attrs: {
                                                    id: "insurancesName",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        operation.debtorLifeInsuranceTypeName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      operation.fireInsuranceType
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "is-flex is-flex-wrap-wrap",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "is-size-7 has-text-grey has-text-weight-semibold",
                                                  attrs: {
                                                    id: "insurancesType",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        operation.fireInsuranceType
                                                          ? _vm.$t(
                                                              "fireInsurance"
                                                            )
                                                          : ""
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "is-size-7 has-text-grey ml-1",
                                                  attrs: {
                                                    id: "insurancesName",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        operation.fireInsuranceTypeName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      operation.creditInsuranceType
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "is-flex is-flex-wrap-wrap",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "is-size-7 has-text-grey has-text-weight-semibold",
                                                  attrs: {
                                                    id: "insurancesType",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        operation.creditInsuranceType
                                                          ? _vm.$t(
                                                              "creditInsurance"
                                                            )
                                                          : ""
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "is-size-7 has-text-grey ml-1",
                                                  attrs: {
                                                    id: "insurancesName",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        operation.creditInsuranceTypeName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      operation.unemploymentInsuranceType
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "is-flex is-flex-wrap-wrap",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "is-size-7 has-text-grey has-text-weight-semibold",
                                                  attrs: {
                                                    id: "insurancesType",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        operation.unemploymentInsuranceType
                                                          ? _vm.$t(
                                                              "unemploymentInsurance"
                                                            )
                                                          : ""
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "is-size-7 has-text-grey ml-1",
                                                  attrs: {
                                                    id: "insurancesName",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        operation.unemploymentInsuranceTypeName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "notPermissions" } }, [
      _c("p", [
        _vm._v(
          "Usted no tiene permisos para ver este menú. Consulte al equipo de desarrollo para más información."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "is-flex mb-4" }, [
      _c(
        "span",
        {
          staticClass:
            "icon-item is-flex is-align-items-center is-justify-content-center",
        },
        [
          _c("i", {
            staticClass: "fa-solid fa-dollar-sign has-text-primary is-size-5",
          }),
        ]
      ),
      _c("span", [
        _c(
          "h4",
          { staticClass: "has-text-grey has-text-weight-medium is-size-6" },
          [_vm._v("Mis créditos")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }